import React from "react";
import { Edit } from "react-admin";
import { EditActions } from "../../common/form/FormActions";
import { DvirFormsForm } from "./DvirFormsForm";
import { useNotification } from "../../../common/hooks/useNotification";
import { useFieldPermissions } from "../../../common/hooks/useFieldPermissions";
import { protectedEntities } from "../../../common/auth/permissions";
import { FieldPermissionsContext } from "../../common/field-permissions/FieldPermissionsContext";

interface IDvirFormEditProps {}

export const DvirFormEdit = (props: IDvirFormEditProps) => {
  const notify = useNotification(props, "editSuccess");
  const fieldPermissions = useFieldPermissions(
    protectedEntities.DvirForm,
    (x) => x.edit
  );
  return (
    <FieldPermissionsContext.Provider value={fieldPermissions}>
      <Edit
        {...props}
        actions={<EditActions />}
        onSuccess={notify}
        mutationMode="pessimistic"
        title="resources.admin-dvir-forms.title.edit">
        <DvirFormsForm />
      </Edit>
    </FieldPermissionsContext.Provider>
  );
};
